import AreaManager from "../components/area/manager/AreaManager";

const routes = [
  { path: "/area/subject/manager", component: AreaManager }
];

export default routes;
